import * as React from 'react';
import styled from 'styled-components';

import Typography from '@components/basics/typography';
import Flex from '@components/layout/flex';

import InviteStatusMarker from './invite-status-marker';
import { InviteStatus } from '@common/types/invites/invite-status';
import { TracInvite } from '@services/invites/types/trac-invite';
import { TracInviteTypes } from '@services/invites/types/invite-types';

import MenuDropdown from '@webapp/controllers/form/menu-dropdown';
import { Option } from '@webapp/types/common/option';

interface InviteProps {
  className?: string;
  label: string;
  status: InviteStatus;
  actions?: React.ReactElement[];
  invite: TracInvite;
  type?: TracInviteTypes;
  handleMenu: (action: string, invite: TracInvite) => void;
}

const menuOptions: Option[] = [
  { label: 'Cancel Invite', value: 'cancel-invite' },
  { label: 'Resend Invite', value: 'resend-invite' },
  { label: 'Accept Invite', value: 'accept-invite' },
  { label: 'Reject Invite', value: 'reject-invite' },
];

export const Invite: React.FC<InviteProps> = (props) => {
  const getAction = () => {
    if (!props.type && props.invite.status === 'pending') {
      //reject
      //accept
      return menuOptions.filter((val) => {
        if (val.value === 'reject-invite' || val.value === 'accept-invite') {
          return true;
        } else {
          return false;
        }
      });
    }

    if (props.type && props.invite.status === 'accepted') {
      //cancel
      return menuOptions.filter((val) => {
        if (val.value === 'cancel-invite') {
          return true;
        } else {
          return false;
        }
      });
    }

    if (props.type && props.invite.status === 'pending') {
      //cancel
      //resend
      return menuOptions.filter((val) => {
        if (val.value === 'cancel-invite' || val.value === 'resend-invite') {
          return true;
        } else {
          return false;
        }
      });
    }

    return undefined;
  };

  return (
    <Flex justifyContent="space-between" className={props.className}>
      <Flex
        className="text-container"
        justifyContent="flex-start"
        alignItems="center"
      >
        <InviteStatusMarker status={props.status} />
        <Typography className="invite-label" weight="700">
          {props.label}
        </Typography>
      </Flex>
      <Flex className="action" justifyContent="flex-end" alignItems="center">
        {/* {props.actions?.map((el, i) => (
          <span key={`invite-actions-${i}`} className="action-item">
            {el}
          </span>
        ))} */}
        <MenuButton>
          <MenuDropdown
            isSmall
            hasDottedIcon
            menuContent={getAction()}
            onSelect={(action) => props.handleMenu(action, props.invite)}
          />
        </MenuButton>
      </Flex>
    </Flex>
  );
};

export default styled(Invite)`
  background: ${({ theme }) => theme.colors.differentBackground};
  border-radius: 4px;
  padding: 0 10px;
  height: 48px;
  user-select: none;

  @media ${({ theme }) => theme.device.laptopL} {
    height: 60px;
    padding: 0 20px;
  }

  .text-container {
    overflow: hidden;
  }

  .invite-label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .action {
    @media ${({ theme }) => theme.device.laptopS} {
      pointer-events: none;
      width: 0;
      white-space: nowrap;
      transition: opacity
        ${({ theme }) =>
          `${theme.transitions.duration} ${theme.transitions.type}`};
    }

    .action-item {
      opacity: 0.5;
      transition: opacity
          ${({ theme }) =>
            `${theme.transitions.duration} ${theme.transitions.type}`},
        color
          ${({ theme }) =>
            `${theme.transitions.duration} ${theme.transitions.type}`};
      margin-left: 10px;

      @media ${({ theme }) => theme.device.tablet} {
        margin-left: 20px;
      }

      &:hover {
        opacity: 1;
      }

      &:first-child {
        margin-left: 0;
      }
    }
  }

  &:hover {
    .action {
      @media ${({ theme }) => theme.device.laptopS} {
        pointer-events: initial;
        width: auto;
        opacity: 1;
      }
    }
  }
`;

const MenuButton = styled.button`
  background-color: ${({ theme }) => theme.colors.secondary};
  width: 24px;
  height: 24px;
  margin-left: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  padding: 0;
  position: relative;
  margin-left: 9px;
  transition: background-color
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};

  &:hover {
    background-color: ${({ theme }) => theme.colors.secondaryDark};
  }

  svg {
    width: 24px;
    height: 24px;
  }
`;
